export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  // Prioriza recursos críticos
  const prioritizeResources = () => {
    // Preload de fontes críticas
    const fontPreloads = document.querySelectorAll<HTMLLinkElement>(
      'link[rel="preload"][as="font"]',
    );

    fontPreloads.forEach((link) => {
      link.setAttribute('fetchpriority', 'high');
    });

    // Marca CSS crítico com alta prioridade
    const stylesheets = document.querySelectorAll<HTMLLinkElement>(
      'link[rel="stylesheet"]',
    );

    stylesheets.forEach((link, index) => {
      if (index < 2) {
        link.setAttribute('fetchpriority', 'high');
      } else {
        link.setAttribute('fetchpriority', 'low');
      }
    });

    // Nota: setAttribute('defer') não tem efeito em scripts já no DOM
    // Scripts de terceiros devem ser configurados com defer no nuxt.config.ts
  };

  // Reduz o tamanho das imagens automaticamente
  const optimizeImages = () => {
    const images = document.querySelectorAll<HTMLImageElement>(
      'img[src*=".webp"], img[src*=".png"], img[src*=".jpg"]',
    );

    images.forEach((img) => {
      // Adiciona lazy loading para imagens não críticas
      if (!img.classList.contains('critical')) {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
      }
    });
  };

  // Otimiza scripts de terceiros
  const optimizeThirdPartyScripts = () => {
    // Adia carregamento de scripts não-essenciais
    if ((window as any)._smartico) {
      // Smartico já carregado, não precisa fazer nada
      return;
    }

    // Adiciona observer para carregar scripts quando necessário
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement;
            const scriptSrc = target.dataset.src;

            if (scriptSrc) {
              const script = document.createElement('script');

              script.src = scriptSrc;
              script.async = true;
              document.head.appendChild(script);
              observer.unobserve(target);
            }
          }
        });
      },
      { rootMargin: '50px' },
    );

    // Aplica observer a elementos que precisam de scripts
    document.querySelectorAll('[data-lazy-script]').forEach((el) => {
      observer.observe(el);
    });
  };

  // Executa otimizações
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      prioritizeResources();
      optimizeImages();
      optimizeThirdPartyScripts();
    });
  } else {
    prioritizeResources();
    optimizeImages();
    optimizeThirdPartyScripts();
  }

  // Nota: Remoção de preloads não utilizados pode causar problemas
  // e não traz benefício significativo - removido
});
